module.exports = __webpack_public_path__ + "static/media/bg-intro-tablet.f22a9ae4.png";